/*
 * contains a value withing two [ min, max ] boundaries meaning that,
 * should the value be outside the boundary the returned value is equal
 * to the closest boundary
 * 
 * clamp(1, 5, 10) -> 5
 * 
 * clamp(14, 5, 10) -> 10
 * 
 * clamp(7, 5, 10) -> 7
 */
module.exports = function clamp (value, min, max) {
  return Math.min(Math.max(min, value), max)
}
